import { createRoot } from "react-dom/client";
import Main from "./app/js/Main";
import * as serviceWorker from "./serviceWorker";

import configureStore from "./app/js/redux/Store";

/**
 * Import all of the CSS files here. Styles in the CSS will have the priority in the
 * order of files imported.
 *
 * node-sass-chokidar module will be monitoring all of the SCSS files in the project and will write a CSS file in the same
 * directoty with the same name. Since React does not understand SCSS, the CSS file needs to be imported here. These CSS
 * files will also commited to Git.
 *
 * NOTE: If chokidar does not update the styles changes, restart the development server.
 *
 */
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import 'intro.js/introjs.css';
import 'intro.js/minified/introjs.min.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import "./app/styles/css/bootstrap-grid.min.css";
import './app/styles/css/main.scss';
import "./app/styles/css/style.scss";

const store = configureStore();

createRoot(document.getElementById("root")).render(<Main store={store} />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
